import React from "react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import color from "../../../Constants/colors";
import { VoicesPostState } from "../../../Enums/voices";
import { VoicesPost } from "../../../Models/voicesPosts";
import { VoicesStatusTag } from "../Common/VoicesFilterParts";

interface Props {
  post: VoicesPost;
}

const STATE_KEYS: Record<VoicesPostState, string> = {
  [VoicesPostState.DRAFT]: "stateDraft",
  [VoicesPostState.IN_APPROVAL]: "stateInApproval",
  [VoicesPostState.SCHEDULED]: "stateScheduled",
  [VoicesPostState.PUBLISHED]: "statePublished",
  [VoicesPostState.FAILED]: "stateFailed",
};

export const STATE_TONES: Record<VoicesPostState, string> = {
  [VoicesPostState.DRAFT]: color.gray600,
  [VoicesPostState.IN_APPROVAL]: color.blue700,
  [VoicesPostState.SCHEDULED]: color.orange600,
  [VoicesPostState.PUBLISHED]: color.green700,
  [VoicesPostState.FAILED]: color.red700,
};

export const rejectionOf = (post: VoicesPost) =>
  post.state === VoicesPostState.DRAFT && post.rejection_note
    ? post.approvals.find((approval) => !approval.approved) ?? null
    : null;

const VoicesPostStateChip: React.FC<Props> = ({ post }) => {
  const { t } = useTranslation("voicesPosts");
  const rejection = rejectionOf(post);
  const tag = (
    <VoicesStatusTag
      label={
        rejection
          ? t(rejection.stopped ? "stateStoppedBy" : "stateRejectedBy", { name: rejection.user })
          : t(STATE_KEYS[post.state])
      }
      tone={rejection ? color.red700 : STATE_TONES[post.state]}
    />
  );

  return rejection?.note ? (
    <Tooltip title={rejection.note}>
      <span>{tag}</span>
    </Tooltip>
  ) : (
    tag
  );
};

export default VoicesPostStateChip;
